import React, { Component } from 'react';
import './index.scss';

import Spinner from "../spinner/index";
import Grid from 'material-ui/Grid';

import {observer,inject} from 'mobx-react';
import PlanItem from "./planItem";
import {withRouter} from 'react-router';

@inject("projectDataStore")
@observer
class Plan extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { loading, plans, planIdSelected } = this.props.projectDataStore;
        return (
            <div>
                { loading ? <Spinner isLoading={loading} /> :
                    <div className="plans">
                        <div className="plan">
                            <Grid container spacing={16}>
                                {
                                    plans.map( (data, key) => {
                                        return(
                                            <Grid item xs={12} sm={6} md={4} key={data.title+data.id}>
                                                <PlanItem
                                                    planData={data}
                                                    isSelect={(key === 0 && data.id === planIdSelected) || data.id === planIdSelected}
                                                />
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default withRouter(Plan);


// WEBPACK FOOTER //
// ./src/components/wizard/plan.js